import { render, staticRenderFns } from "./collegePlan.vue?vue&type=template&id=e293cee6&scoped=true&"
import script from "./collegePlan.vue?vue&type=script&lang=js&"
export * from "./collegePlan.vue?vue&type=script&lang=js&"
import style0 from "./collegePlan.vue?vue&type=style&index=0&id=e293cee6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e293cee6",
  null
  
)

export default component.exports